import { errorDescription, errorStackTrace } from "./js-utils"

const copyErrorToClipboard = (error: unknown) => {
  const errorText = errorStackTrace(error) ?? errorDescription(error) // stack trace includes the error description
  navigator.clipboard.writeText(errorText)
}

export { copyErrorToClipboard }
